import { DispatchBanner, Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { CTA } from "@/components/CTA";
import { MapPin } from "lucide-react";
import InteractiveMap from "@/components/InteractiveMap";
import { SEO } from "@/components/SEO";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { motion } from "framer-motion";

export default function ServiceAreas() {
  return (
    <div className="flex flex-col min-h-screen pb-28 md:pb-0 bg-white font-sans text-gray-900">
      <SEO
        title="Service Areas | KY, TN, OH, IN | 911 Sourcing"
        description="We provide dedicated logistics, emergency salt supply, and wholesale plant sourcing across Kentucky, Tennessee, Ohio, and Indiana."
        url="/service-areas"
      />
      <DispatchBanner />
      <Navbar />

      <main className="flex-grow">
        <section className="bg-salt-dark py-20 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8"
          >
            <h1 className="text-4xl md:text-5xl font-black text-white uppercase tracking-tighter mb-6">
              Our <span className="text-salt-orange">Service Areas</span>
            </h1>
            <p className="text-lg text-gray-300">
              We provide dedicated logistics, salt supply, and plant sourcing
              across the Midwest and Mid-South regions.
            </p>
          </motion.div>
        </section>

        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <Breadcrumbs items={[{ label: "Service Areas" }]} />
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-3xl font-black uppercase tracking-tighter text-salt-dark mb-6">
                  Regional Coverage
                </h2>
                <p className="text-gray-600 mb-8">
                  Our strategic location in Kentucky allows us to effectively
                  service a massive geographic footprint. With access to major
                  river terminals and interstate arteries, we can rapidly deploy
                  freight to where it's needed most.
                </p>

                <div className="grid grid-cols-2 gap-6">
                  <a
                    href="/service-areas/kentucky"
                    className="bg-gray-50 p-6 rounded-lg border border-gray-100 flex items-start gap-4 hover:border-salt-orange hover:shadow-md transition-all group"
                  >
                    <MapPin className="w-6 h-6 text-salt-orange flex-shrink-0" />
                    <div>
                      <h3 className="font-black text-lg uppercase tracking-tight text-salt-dark mb-1 group-hover:text-salt-orange transition-colors">
                        Kentucky
                      </h3>
                      <p className="text-sm text-gray-500">
                        Statewide coverage including Louisville, Lexington, and
                        NKY.
                      </p>
                    </div>
                  </a>
                  <a
                    href="/service-areas/ohio"
                    className="bg-gray-50 p-6 rounded-lg border border-gray-100 flex items-start gap-4 hover:border-salt-orange hover:shadow-md transition-all group"
                  >
                    <MapPin className="w-6 h-6 text-salt-orange flex-shrink-0" />
                    <div>
                      <h3 className="font-black text-lg uppercase tracking-tight text-salt-dark mb-1 group-hover:text-salt-orange transition-colors">
                        Ohio
                      </h3>
                      <p className="text-sm text-gray-500">
                        Cincinnati, Dayton, Columbus, and surrounding areas.
                      </p>
                    </div>
                  </a>
                  <a
                    href="/service-areas/indiana"
                    className="bg-gray-50 p-6 rounded-lg border border-gray-100 flex items-start gap-4 hover:border-salt-orange hover:shadow-md transition-all group"
                  >
                    <MapPin className="w-6 h-6 text-salt-orange flex-shrink-0" />
                    <div>
                      <h3 className="font-black text-lg uppercase tracking-tight text-salt-dark mb-1 group-hover:text-salt-orange transition-colors">
                        Indiana
                      </h3>
                      <p className="text-sm text-gray-500">
                        Indianapolis, Evansville, Fort Wayne, and statewide.
                      </p>
                    </div>
                  </a>
                  <a
                    href="/service-areas/tennessee"
                    className="bg-gray-50 p-6 rounded-lg border border-gray-100 flex items-start gap-4 hover:border-salt-orange hover:shadow-md transition-all group"
                  >
                    <MapPin className="w-6 h-6 text-salt-orange flex-shrink-0" />
                    <div>
                      <h3 className="font-black text-lg uppercase tracking-tight text-salt-dark mb-1 group-hover:text-salt-orange transition-colors">
                        Tennessee
                      </h3>
                      <p className="text-sm text-gray-500">
                        Nashville, Knoxville, Memphis, and statewide.
                      </p>
                    </div>
                  </a>
                </div>
              </div>

              <div>
                <InteractiveMap />
              </div>
            </div>
          </div>
        </section>

        <CTA />
      </main>

      <Footer />
    </div>
  );
}
